module.exports = __webpack_public_path__ + "static/img/dtfh.b8b971d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dtfh.png
// module id = 09U5
// module chunks = 0